import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styles from "../styles.module.css";
function Price({ gross, nett }) {
    return nett !== gross ? (_jsxs("p", { children: [_jsx("span", { className: styles.strike, children: gross }), " ", _jsx("span", { className: `${styles.bold} ${styles.blue}`, children: nett })] })) : (_jsx("p", { className: styles.bold, children: nett }));
}
export default Price;
